import Navbar from '../../layout/Navbar'
import HomeSearch from "../../components/elements/HomeSearch"
import SearchCapsules from "../../components/elements/SearchCapsules"
import Banner from '../../assets/images/hero.png'
import namaste from "../../assets/images/namaste.png";

import TourCard from '../../components/cards/TourCard';
import { Link, useNavigate } from 'react-router-dom';
import OfferCard from '../../components/cards/OfferCard';
import TrendingCard from '../../components/cards/TrendingCard';
import { useFetch } from '../../hooks/useFetch';

import { getToursAndEvents, upcomingToursAndEvents } from '../../apis';
import { useMemo, useState } from 'react';
import useWidth from '../../hooks/useWidth';
import MobileHeader from '../../layout/MobileHeader';
import MobileHeaderSearch from '../../components/MobileHeaderSearch';
import Loader from '../../components/elements/Loader';
import ImageSlider from '../../components/elements/ImageSlider';
import { SwiperSlide } from 'swiper/react';



export default () => {
    const width = useWidth()
    const  navigate = useNavigate()
    const [toursAndEvents,,loading] = useFetch(getToursAndEvents, {})
    const [upcomingToursAndEvent] = useFetch(upcomingToursAndEvents, [])

    const [ allTours, allEvents ] = useMemo(() => {
        
        const tours = toursAndEvents.allEventsTours?.filter( t => t.type === "tour" )
        const events = toursAndEvents.allEventsTours?.filter( t => t.type === "event" )
        return [ tours, events ]

    }, [ toursAndEvents ])


    const handleSearch = ( search ) => {
        navigate(`/tours-events/category?search=${search}`)
    }

    return (
        <>
            <Loader loading={loading} />
            {
                width > 992
                    ? <>
                        <Navbar />
                        <section className="">
                            <div className="d-flex justify-content-center align-items-end" style={{ height: "100vh", background: `url(${Banner})` }}>
                                <div className="mb-5 pb-5">

                                    <div className="namaste mb-4">
                                        <img src={namaste} />
                                    </div>
                                    <HomeSearch placeholder="Search Tours & Events" onSearch={handleSearch} />
                                    <p className="bold text-white text-center fs-4 my-4">Recent Searches</p>
                                    <div className="d-flex flex-wrap container">
                                        <SearchCapsules />
                                        <SearchCapsules />
                                        <SearchCapsules />
                                        <SearchCapsules />
                                        <SearchCapsules />
                                    </div>
                                </div>
                            </div>
                        </section>

                    </>
                    : <MobileHeader>
                        <MobileHeaderSearch placeholder="Search Tours & Events" onSearch={handleSearch} />
                    </MobileHeader>
            }
            

            <div className="container d-flex justify-content-between align-items-center  mobile-top-space">
                <h3 className='text-saffron'>Upcoming Events</h3>
                <Link to={'/tours-events/category?categoryId=event'} className='secondary-btn'>View All</Link>
            </div>
            <section className='tour-event-section mt-5'>

                <div className='row d-flex gap-2 overflow-auto p-0 m-0 w-100 flex-nowrap scrollbar-hidden'>
                    {
                        allEvents?.map(( event, i ) =>
                            <div className='col-lg-3 col-md-4 col-sm-12 p-0' key={i}>
                                <TourCard data={event} />
                            </div>
                        )
                    }

                </div>
            </section>


            <div className='overflow-auto scrollbar-hidden mt-5 '>
                <div className="row flex-nowrap ms-3">
                    <ImageSlider slidesPerView={Math.fround(width / (width > 992 ? 950 : 420)).toFixed(1)}>
                        {
                            upcomingToursAndEvent?.map((tour, i) =>
                                <div className='col-lg-8 col-md-12' >
                                    <SwiperSlide>
                                        <TrendingCard data={tour} />
                                    </SwiperSlide>
                                </div>
                            )
                        }
                    </ImageSlider>
                </div>
            </div>




            <div className="container mt-5 d-flex justify-content-between align-items-center">
                <h3 className='text-primary'>Upcoming Tours</h3>
                <Link to={'/tours-events/category?categoryId=tour'} className='secondary-btn border-primary text-primary'>View All</Link>
            </div>
            <section className='tour-event-section mt-5'>

                <div className='row d-flex gap-2 overflow-auto w-100 flex-nowrap scrollbar-hidden p-0 m-0'>
                    {
                        allTours?.map(( tour, i ) =>
                            <div className='col-lg-3 col-md-4 col-sm-12 p-0' key={i}>
                                <TourCard data={tour} />
                            </div>
                        )
                    }

                </div>
            </section>



            <div className="offers">
                <div className="row mx-0 px-5 pt-5">
                    <div className="col-md-8 p-0">
                        <div className="top-heading">Offers Tailored For You</div>
                    </div>
                    <div className="col-md-4 d-flex justify-content-end">
                        <Link to={'/offers'} className="view-all w-50">Know More</Link>
                    </div>
                </div>

                <div className="row  mx-0 my-5 ">
                    <ul className="list-unstyled d-flex offers-card-list-mobile  mobileScrollBar">
                        <li className="m-2">
                            <div className="bg-dark rounded offers-card-container">
                                <OfferCard data={"Get upto 15% off on your First Booking"} />
                            </div>
                        </li>

                        <li className="m-2">
                            <div className="bg-dark rounded offers-card-container">
                                <OfferCard data={"Budget Friendly Homestays"} />
                            </div>
                        </li>
                    </ul>

                </div>
            </div>

        </>
    )
}